import { render } from "./PlaylistElement.vue?vue&type=template&id=2d7f44b5"
import script from "./PlaylistElement.vue?vue&type=script&lang=ts"
export * from "./PlaylistElement.vue?vue&type=script&lang=ts"
script.render = render

export default script